import controller from './thing-details.controller';

const template = require('./thing-details.html');

export default {
    bindings: {
        thing: '<',
        thingUpdate: '<',
        onThingUpdated: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details.component.js